import { createSelector } from 'reselect';
import { ScreenSize } from './../../../styles/screen-sizes';
import { IStore } from '../IStore';
import { ToastPayload } from './presentation-models';

export const selectToast = (state: IStore): ToastPayload | undefined => state.presentation.toast;
export const selectModalContent = (state: IStore): JSX.Element | undefined =>
  state.presentation.modalContent;
export const selectOnClose = (state: IStore): (() => void) | undefined =>
  state.presentation.onClose;
export const selectScreenSize = (state: IStore): ScreenSize =>
  state.presentation.screenSize !== undefined ? state.presentation.screenSize : ScreenSize.XL;

export const selectIsMobileSize = createSelector([selectScreenSize], (screenSize) => {
  return screenSize === ScreenSize.XS;
});
